import { useState } from "react";

import "./PageName.css";

import { Btn } from "../Input";

interface props {
    title: string;
    subtitle: string;
    btn_title?: string;
    btn_function?: () => void;
}

export default function Comp_PageName(props: props) {

    return (
        <div className="Comp_PageName">
            <div className="name_page">                
                <div className="title">{ props.title }</div>
                <div className="subtitle">{ props.subtitle }</div>
            </div>

            {
                props.btn_title ? 
                    <div className="btn">
                        <Btn title={ props.btn_title } type="div" OpenFuncition={ ()=>{ props.btn_function && props.btn_function() } } />
                    </div>
                : null
            }
        </div>
    );
}